/** Per-skin brand colour sources for <LoginBrandActions />.
 *
 *  This is the ONLY file that differs between skins — the component itself is
 *  identical everywhere. Values are used exactly as the brand's variables.css
 *  defines them; nothing here is adjusted at runtime.
 *
 *  Order matters. `--secondary` is a shared boilerplate navy that nearly every
 *  brand in this skin inherits unchanged, so it is NOT the brand colour — the
 *  brand's real accent is --primarySvgColor / --primaryGradientColor, which is
 *  what the site already uses for its own primary buttons (exposed to Tailwind
 *  as bg-buttonGradient). Those come first; --secondary is only a last resort.
 */
export const BRAND_CTA_VARS = {
  /** Ready-made brand gradient, used verbatim for the filled button. */
  gradient: ["--primaryGradientColor"],
  /** Solid brand colour: outlined button's border/label, and the glow. */
  accent: ["--primarySvgColor", "--secondary", "--primary"],
  /** Far stop when a gradient has to be synthesised from the accent. */
  base: ["--primary"],
  /** Used when a brand ships no usable theme vars. Matches the greens the
   *  legacy hardcoded login buttons used. */
  fallbackAccent: "#2e7d32",
  fallbackBase: "#1b5e20",
};
